var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_84804)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_782_84804)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_782_84804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_782_84804)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_782_84804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_782_84804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 19.1667C10.608 19.1664 11.1907 18.9249 11.6203 18.4952C12.0499 18.0654 12.2912 17.4826 12.2912 16.875H7.70785C7.70785 17.176 7.76715 17.4741 7.88237 17.7522C7.99759 18.0303 8.16647 18.2829 8.37935 18.4957C8.59224 18.7086 8.84497 18.8773 9.12311 18.9925C9.40124 19.1076 9.69933 19.1668 10.0003 19.1667ZM17.7128 13.8058C17.0212 13.0625 15.727 11.9442 15.727 8.28084C15.7281 6.96674 15.2713 5.69332 14.4354 4.67942C13.5994 3.66552 12.4364 2.97446 11.1462 2.725V1.975C11.1462 1.82464 11.1166 1.67575 11.059 1.53683C11.0015 1.39791 10.9171 1.27169 10.8108 1.16536C10.7045 1.05904 10.5783 0.974701 10.4394 0.91716C10.3004 0.859618 10.1515 0.830002 10.0012 0.830002C9.85082 0.830002 9.70193 0.859618 9.56301 0.91716C9.42409 0.974701 9.29787 1.05904 9.19154 1.16536C9.08522 1.27169 9.00088 1.39791 8.94334 1.53683C8.8858 1.67575 8.85618 1.82464 8.85618 1.975V2.725C7.56552 2.97394 6.40192 3.66478 5.56545 4.67873C4.72898 5.69268 4.27192 6.96639 4.27285 8.28084C4.27285 11.9475 2.97868 13.0625 2.28701 13.8058C2.08792 14.0155 1.97772 14.2942 1.97951 14.5833C1.97962 14.7341 2.00945 14.8833 2.06728 15.0225C2.12511 15.1617 2.20981 15.2881 2.31654 15.3945C2.42327 15.5009 2.54994 15.5853 2.68929 15.6427C2.82865 15.7001 2.97796 15.7295 3.12868 15.7292H16.872C17.0227 15.7295 17.172 15.7001 17.3114 15.6427C17.4508 15.5853 17.5774 15.5009 17.6842 15.3945C17.7909 15.2881 17.8756 15.1617 17.9334 15.0225C17.9912 14.8833 18.0211 14.7341 18.0212 14.5833C18.0228 14.294 17.9123 14.0154 17.7128 13.8058Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_84804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_782_84804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.596587ec35be5317ffdd6ede0408508e.svg";
export { ForwardRef as ReactComponent };